import React from "react"
import { T } from "../../traks"

export const plans = [
    {
        id: 1,
        months: 1,
        label: <T>1 month</T>,
        monthlyPrice: <T>18 kr.</T>,
        totalPrice: <T>18 kr.</T>,
    },
    {
        id: 2,
        months: 3,
        label: <T>3 months save 33%</T>,
        monthlyPrice: <T>12 kr.</T>,
        totalPrice: <T>36 kr.</T>,
        discountPrice: <T>54 kr.</T>,
    },
    {
        id: 3,
        months: 6,
        label: <T>6 months save 50%</T>,
        monthlyPrice: <T>9 kr.</T>,
        totalPrice: <T>54 kr.</T>,
        discountPrice: <T>108 kr.</T>,
    },
    {
        id: 4,
        months: 12,
        label: <T>12 months save 66%</T>,
        monthlyPrice: <T>6 kr.</T>,
        totalPrice: <T>72 kr.</T>,
        discountPrice: <T>216 kr.</T>,
    }
]


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumPlansData.js